import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'fd-is-card',
  templateUrl: './fd-is-card.component.html',
  styleUrls: ['./fd-is-card.component.scss']
})
export class FdIsCardComponent implements OnChanges {
  @Input() color!: string;
  @Input() boxShadow!: string;
  @Input() text!: string;
  @Input() value!: string | number | null;
  @Input() width!: string;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['width']) {
      this.width = changes['width'].currentValue;
    }
  }
}
